<template>
    <div class="g-product-list">
        <h3 v-if="product.length === 0" class="text-md-center">
            {{$t('products.item_not_found')}}
        </h3>
        <v-container grid-list-md text-xs-center v-if="product && product.displayDetails" class="current-prod-detail-sect">
           <div class="go-back-btn-sect">
               <v-btn
                       slot="activator"
                       color="transparent"
                       class="go-back-btn"
                       :ripple="false"
                       to="/products"
               >
                   <v-icon>icon-arrow-347</v-icon>
                   <span>{{$t('products.back_to_products')}}</span>
               </v-btn>
           </div>
            <v-layout row wrap :class="relatedProducts.length ? 'is-related-prods' : ''" class="g-card g-card-product">
                <v-flex sm6 md6 lg6 class="img-slider-sect">
                    <image-carousel
                            :images="product.options && product.options.images"
                            :generalImage="product.image"
                            :product="product"
                            :key="renderingImageCarousel"
                            :compUser="compUser"
                    />
                </v-flex>
                <v-flex sm6 md6 lg6 class="product-info-section">
                    <v-layout column wrap class="ex-item">
                        <div class="d-flex justify-space-between align-center product-name-sect">
                            <div class="text-md-left">
                                <v-card-text v-if="product.displayDetails">
                                    <h1 class="px-0 ex-item-name">
                                        {{product.displayDetails.name}}</h1>
                                </v-card-text>
                            </div>
                            <button class="ex-fav-good" v-if="product.userId !== loggedUser.id" @click="addToFavorite(product)"><i :class="{ 'icon-favorite-2': product.favorite, 'icon-favorite-1': !product.favorite }"/></button>
                            <div class="text-md-left edit-prod-btn-sect" v-else-if="product.userId === loggedUser.id && !requestedOption.isGiven">
                                <v-card-text>
                                    <v-icon  @click="redirectProductEditPage(product, breadcrumb)">icon-edit-profile</v-icon>
                                </v-card-text>
                            </div>
                        </div>

                        <div class="text-md-left prod-info">
                            <v-flex class="d-flex info-sect">
                                <v-flex v-if="product.displayDetails && product.displayDetails.location" class="location-card-sect">
                                    <v-card-text class="ex-item-location">
                                        <v-icon class="m-r-12">icon-location</v-icon>
                                        <span class="location-text">{{ product.displayDetails.location }}</span>
                                    </v-card-text>
                                </v-flex>
                                <v-flex class="categories-card-sect d-flex">
                                    <v-icon class="f-s-13 m-r-12">icon-goods</v-icon>
                                    <v-breadcrumbs :items="breadcrumb" divider="/">
                                        <template slot="item" slot-scope="props">
                                            {{ props.item.text }}
                                        </template>
                                    </v-breadcrumbs>
                                </v-flex>
                            </v-flex>
                        </div>

                        <div class="text-md-left friends-avatar-sect">
                            <v-flex v-if="product.User" class="avatar-section">
                                <v-card-text>
                                    <v-avatar
                                            slot="activator"
                                            size="35px"
                                    >
                                        <router-link v-if="product.User.image" :to="/accounts/ + product.User.id">
                                            <img
                                                :src="`${ROOT_API}${product.User.image}`"
                                                :alt="$t('avatar')"
                                            >
                                        </router-link>
                                        <router-link v-else :to="/accounts/ + product.User.id">
                                        <v-icon
                                                :color="`red`"
                                                v-text="`people`"
                                        />
                                        </router-link>
                                    </v-avatar>
                                    <span class="ex-user-name" v-html="product.User.firstName + ' ' + (product.User.lastName || '')"/>
                                </v-card-text>
                            </v-flex>
                        </div>
                        <v-flex class="text-md-left prod-description-text-sect">
                            <v-card-text
                                    class="ex-item-description"
                                    v-if="product.displayDetails"
                            >{{product.displayDetails.description}}</v-card-text>
                        </v-flex>

                        <v-flex
                                class="text-md-left prod-request-btn-sect"
                                v-if="!requestedOption.requested && product.userId !== loggedUser.id">
                            <v-btn
                                    class="send-prod-req-btn"
                                   :disabled=requestDisabled
                                   @click.native="openRequestModal"
                                    :ripple="false"
                            >
                                {{ $t('products.send_request')}}
                            </v-btn>
                        </v-flex>
                        <div class="text-md-left req-done-message-sect" v-else-if="requestedOption.requested && product.userId !== loggedUser.id">
                            <v-card-text v-if="requestedOption.isGiven === null">
                                <span class="px-0">{{$t('products.requested')}} </span>
                                <v-icon color="green" right>icon-check</v-icon>
                            </v-card-text>
                            <v-card-text v-else-if="requestedOption.isGiven">
                                <span class="px-0">{{ $t('products.requestAccepted') }} </span>
                                <v-icon color="green" right>icon-check</v-icon>
                            </v-card-text>
                            <v-card-text v-else>
                                <span>{{ $t('products.requestRejected') }} </span>
                                <v-icon color="red" right>icon-cancel</v-icon>
                            </v-card-text>
                            <v-card-text v-if="requestedOption.isGiven && requestedOption.contactBy">
                                <span class="px-0">{{ requestedOption.contactBy }} </span>
                            </v-card-text>
                        </div>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout>
            </v-layout>
            <v-dialog v-model="dialog" max-width="550px">
                <v-form ref="form" v-model="valid" lazy-validation class="disable-form-contact">
                    <v-card color="grey lighten-4">
                        <v-card-title class="cancel-btn-card-sect">
                          <v-btn class="cancel-request-btn1" :ripple="false" @click.native="closeModal">
                               <v-icon>icon-cancel</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-title class="text-md-center card-first-sect">
                            <span class="modal-headline">{{$t('products.send_request_message')}}</span>
                        </v-card-title>
                        <v-card-text class="p-0-14">
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex>
                                      <v-textarea
                                        v-model="requestMessage"
                                        :rules="requestMessageRules"
                                        :counter="150"
                                        name="requestMessage"
                                        :no-resize="true"
                                        outline
                                        class="modal-text-field ex-input-group"
                                        :placeholder="$t('settings.description')"
                                      >
                                      </v-textarea>
                                      <p style="color: red">{{errors.messageError}}</p>
                                      <label class="ex-input-phone modal-text-field">{{ $t('phone_number') }}</label>
                                      <v-flex xs12 class="group-name-input">
                                        <v-text-field
                                          class="ex-input-group"
                                          v-model="userData.phoneNumber"
                                          placeholder="+374XXXXXXXX"
                                          :rules="phoneNumberRules"
                                          required>
                                        </v-text-field>
                                        <p style="color: red">{{errors.phoneNumberError}}</p>
                                      </v-flex>
                                      <label class="ex-input-phone modal-text-field">{{ $t('email') }}</label>
                                      <v-flex xs12 class="group-name-input">
                                        <v-text-field
                                          flat
                                          v-model="userData.email"
                                          :rules="emailRules"
                                          required
                                          color='indigo accent-4'
                                          class="ex-input-group">
                                        </v-text-field>
                                      </v-flex>

                                      <label class="ex-input-phone modal-text-field">{{ $t('country') }}</label>
                                      <v-flex xs12 class="group-name-input">
                                        <v-text-field
                                          class="ex-input-group"
                                          :placeholder="$t('country')"
                                          v-model="userData.country"
                                          :rules="countryRules"
                                          required>
                                        </v-text-field>
                                        <p style="color: red">{{errors.countryError}}</p>
                                      </v-flex>
                                      <label class="ex-input-phone modal-text-field">{{ $t('city') }}</label>
                                      <v-flex xs12 class="group-name-input">
                                        <v-text-field
                                          class="ex-input-group"
                                          v-model="userData.city"
                                          :placeholder="$t('city')"
                                          :rules="cityRules"
                                          required>
                                        </v-text-field>
                                        <p style="color: red">{{errors.cityError}}</p>
                                      </v-flex>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="modal-btn-sect">
                            <v-btn class="cancel-request-btn2" :ripple="false" @click.native="closeModal">{{$t('products.cancel')}}</v-btn>
                            <v-btn class="send-request-btn" :ripple="false" @click.native="sendRequestMessage">{{$t('products.send')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog v-model="dialogConfirm" max-width="550px">
                <v-form ref="formConfirm" v-model="validConfirm" lazy-validation class="disable-form-contact">
                    <v-card class="contact-with-user-modal">
                      <v-card-title class="modal-close-btn-sect">
                        <v-btn
                          class="cancel-user-contact-modal-btn"
                          :ripple="false"
                          flat
                          @click.native="close">
                          <v-icon>icon-cancel</v-icon>
                        </v-btn>
                      </v-card-title>
                        <v-card-title class="text-md-center headline-title title-name">
                            <span>{{$t('profile.contact_me')}}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-xs>
                                <v-layout wrap class="chose-contact-type-sect">
                                    <v-flex xs12 sm12 md12 class="contact-by-type-sect">
                                        <v-layout align-flex-start justify-space-between class="type-cont-main-sect">
                                            <v-checkbox v-model="enabledTel"
                                                        :label="$t('profile.contact_by_phone')"
                                                        color="#8890e4"
                                                        class="shrink mr-2"/>
                                            <v-text-field
                                                    :disabled="!enabledTel"
                                                    v-model="contactByTel"
                                                    :rules="contactByTelRules"
                                                    color="indigo"
                                                    class="shrink mr-2 type-input"
                                                    flat-rigth
                                                    solo
                                                    placeholder="+374XXXXXXXX"
                                            />
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 class="contact-by-type-sect">
                                        <v-layout align-flex-start justify-space-between class="type-cont-main-sect">
                                            <v-checkbox
                                              v-model="enabledEmail"
                                              :label="$t('profile.contact_by_email')"
                                              color="#8890e4"
                                              class="shrink mr-2"/>
                                            <v-text-field
                                                    :disabled="!enabledEmail"
                                                    v-model="contactByEmail"
                                                    :rules="contactByEmailRules"
                                                    color="indigo"
                                                    class="shrink mr-2 type-input"
                                                    flat-rigth
                                                    solo
                                            />
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="modal-btn-sect">
                            <v-spacer></v-spacer>
                            <v-btn class="cancel-request-btn2" :ripple="false" @click.native="close">{{$t('products.cancel')}}</v-btn>
                            <v-btn class="send-request-btn" :ripple="false" @click.native="save" :disabled="!enabledTel && !enabledEmail">{{$t('products.send')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-container>
        <v-container v-if="product && product.ProductRequests && product.ProductRequests.length > 0" class="prod-request-note-sect">
            <v-layout
                     class="main-position-sect">
                <v-flex xs8 lg9 md12 sm10 xs12 class="prod-request-note">
                    <v-list three-line>
                        <template v-for="(item, index) in product.ProductRequests">
                            <v-list-tile
                                    :key="item.id"
                                    avatar
                                    class="notif-sect layout row wrap"
                            >   <router-link :to="/accounts/ + item.User.id">
                                <v-list-tile-avatar class="flex md0 sm1 xs1">
                                    <img v-if="item.User && item.User.image" :src="ROOT_API + item.User.image" :alt="$t('avatar')">
                                    <img v-else src="../../assets/images/NoImage.png" :alt="$t('avatar')">
                                </v-list-tile-avatar>
                                </router-link>
                                <v-list-tile-content class="flex md3 sm6 xs9">
                                    <v-list-tile-title v-html="item.User.firstName + ' ' +  (item.User.lastName || '')"/>
                                </v-list-tile-content>
                                <v-list-tile class="need-message-sect flex md4 sm6 xs10">
                                    <v-list-tile-sub-title v-html="item.message"/>
                                </v-list-tile>
                                <v-list-tile-action v-if="item.accepted !== null" class="flex md4 xs12 status-message-info">
                                    <v-list-tile-action-text v-if="item.accepted" class="accept-text">
                                        <v-icon>icon-accept</v-icon>
                                        {{$t('products.requestAccepted')}}
                                    </v-list-tile-action-text>
                                    <v-list-tile-action-text v-else class="decline-text">
                                        <v-icon>icon-combined-shape-1</v-icon>
                                        {{$t('products.requestRejected')}}
                                    </v-list-tile-action-text>
                                </v-list-tile-action>
                                <v-list-tile-action v-if="item.accepted === null" class="accept-decline-prod-need flex md4 sm6 xs12">
                                    <v-btn class="decline-need-btn" :ripple="false" @click="rejectRequest(item.id, false)" :disabled="isDisabled">{{$t('products.decline')}}
                                       <v-icon>icon-remove-565</v-icon>
                                    </v-btn>
                                    <v-btn class="accept-need-btn" :ripple="false" @click="confirmRequest(item.id)">{{$t('products.accept')}}
                                        <v-icon>icon-check</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider v-if="index +1 < product.ProductRequests.length" :key="`divider-${index}`"/>
                        </template>
                    </v-list>
                </v-flex>
            </v-layout>
        </v-container>
        <related-products v-else-if="relatedProducts.length > 0" :relatedProducts="relatedProducts"/>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import ImageCarousel from './imageCarousel'
import RelatedProducts from './relatedProducts'
import { EventBus } from '../../event-bus'
import { createLocation, validateEmail, changeImageSize } from '../../helpers/main'

export default {
  name: 'CurrentProduct',
  components: {
    ImageCarousel,
    RelatedProducts
  },
  data: () => ({
    errors: {},
    userData: {},
    renderingImageCarousel: false,
    requestMessage: '',
    phoneNum: '',
    requestEmail: '',
    valid: true,
    dialog: false,
    requestDisabled: false,
    items: [],
    ROOT_API: process.env.ROOT_API,
    product: [],
    compUser: [],
    relatedProducts: [],
    breadcrumb: [],
    dialogConfirm: false,
    productId: null,
    enabledTel: false,
    contactByTel: '',
    enabledEmail: true,
    contactByEmail: '',
    validConfirm: true,
    isDisabled: false,
    disabledTimeout: 500,
    requestedOption: {
      requested: false,
      isGiven: null,
      options: {},
      contactBy: ''
    }
  }),
  computed: {
    ...mapState({
      loggedUser: state => state.auth.userData
    }),
    countryRules () {
      return [
        v => !!v || this.$t('country_required')
      ]
    },
    cityRules () {
      return [
        v => !!v || this.$t('city_required')
      ]
    },
    requestMessageRules () {
      return [
        v => (!!v && v.trim() !== '') || this.$t('products.request_message_required'),
        v => (v.length <= 150 && v.length > 50) || this.$t('products.request_desc_valid')
      ]
    },
    contactByTelRules () {
      const rules = []
      if (this.enabledTel) {
        rules.push(v => !!v || this.$t('profile.phone_required'))
        rules.push(v => (!!v && /^\+?(?:[0-9] ?){7,14}[0-9]$/.test(v)) || this.$t('profile.phone_not_valid'))
      }
      return rules
    },
    emailRules () {
      return [
        v => !!v || this.$t('email_required'),
        v => validateEmail(v) || this.$t('email_not_valid')
      ]
    },
    phoneNumberRules () {
      return [
        v => !!v || this.$t('pnone_required'),
        v => (!v || /^\+?(?:[0-9] ?){7,14}[0-9]$/.test(v)) || this.$t('phone_not_valid')
      ]
    },
    contactByEmailRules () {
      const rules = []
      if (this.enabledEmail) {
        rules.push(v => !!v || this.$t('email_required'))
        rules.push(v => validateEmail(v) || this.$t('email_not_valid'))
      }
      return rules
    }
  },
  watch: {
    loggedUser (val) {
      if (this.product && this.product.id) {
        setTimeout(() => {
          this.getProduct(this.product.id)
        }, 0)
      }
    },
    $route (val) {
      // for ForceUpdating Image Carousel Component
      this.renderingImageCarousel = !this.renderingImageCarousel
      if (val.params && val.params.productId) {
        this.getProduct(val.params.productId)
      }
      // this.$store.dispatch('products/setDefaultMetas').then((res) => {}).catch(console.error)
    },
    dialogConfirm (val) {
      val || this.close()
      this.$refs.formConfirm.resetValidation()
    }
  },
  mounted () {
    const parseIntProductId = this.$route.params.productId
    if (parseIntProductId) {
      this.getProduct(parseIntProductId)
    } else {
      this.$router.push('/products')
    }
  },
  methods: {
    getProduct (productId) {
      if (localStorage.getItem('token')) {
        // For loggedIn Users
        this.$store.dispatch('products/getProductWithRequests', productId).then((res) => {
          if (res.user) {
            this.compUser.push(res.user)
          }
          this.getProductResponse(res)
        })
      } else {
        // For not loggedIn Users
        this.$store.dispatch('products/getProduct', productId).then((res) => {
          if (res.user) {
            this.compUser.push(res.user)
          }
          this.getProductResponse(res)
        }).catch(console.error)
      }
      let data = {
        cat: null,
        filter: []
      }
      this.$store.dispatch('categories/setMainSearchData', data)
    },
    languageChanged () {
      this.getProductList(this.product, this.breadcrumb)
      this.getRelatedProducts(this.relatedProducts)
    },
    getProductResponse (res) {
      this.requestedOption = Object.assign(this.requestedOption, res.requestOption)
      this.getProductList(res.product, res.breadcrumb)
      this.getRelatedProducts(res.relatedProducts)
      // Disable or Enable request button
      if (this.loggedUser.id && this.product.userId === this.loggedUser.id) {
        this.requestDisabled = true
      }
    },

    getProductList (product, breadcrumbs) {
      if (breadcrumbs) {
        breadcrumbs.forEach(breadcrumb => {
          breadcrumb.CategoryTranslations.forEach(CategoryTranslation => {
            if (CategoryTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
              breadcrumb.text = CategoryTranslation.name
            } else if (!breadcrumb.text) {
              breadcrumb.text = CategoryTranslation.name
            }
          })
        })
        this.breadcrumb = breadcrumbs
      }
      if (product) {
        product.displayDetails = {}
        product.favorite = false
        product.ProductTranslations.forEach(productTranslation => {
          if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            if (productTranslation.name.match(/և/)) {
              productTranslation.name = productTranslation.name.replace('և', 'եվ').replace(/,\s*$/, '')
              product.displayDetails.name = productTranslation.name
            }
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description
          } else if (!product.displayDetails.name) {
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description
          }
        })
        product.ProductAddresses.forEach(productAddress => {
          let addressData = productAddress.Address
          if (productAddress.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            product.displayDetails.location = createLocation(addressData)
          } else if (!product.displayDetails.location) {
            product.displayDetails.location = createLocation(addressData)
          }
        })
        if (product.FavoriteProducts && product.FavoriteProducts.length > 0) {
          product.FavoriteProducts.forEach(favoriteProduct => {
            if (favoriteProduct.userId === this.loggedUser.id) {
              product.favorite = true
            } else {
              product.favorite = false
            }
          })
        }
        if (this.requestedOption.options) {
          let contactBy = ''
          contactBy = this.$root.$t('profile.contact_by')
          if (this.requestedOption.options.byTel && this.requestedOption.options.byEmail) {
            contactBy = contactBy + this.$root.$t('profile.phone') + this.requestedOption.options.byTel + this.$root.$t('profile.or') + this.$root.$t('profile.email') + this.requestedOption.options.byEmail
          } else {
            contactBy = contactBy + (this.requestedOption.options.byTel ? (this.$root.$t('profile.phone') + this.requestedOption.options.byTel) : (this.$root.$t('profile.email') + this.requestedOption.options.byEmail))
          }
          this.requestedOption.contactBy = contactBy
        }
        this.product = product
      }
    },
    getRelatedProducts (products) {
      if (products) {
        let _products = []
        products.forEach(product => {
          product.image = changeImageSize(product.image, 'md')
          product.displayDetails = {}
          product.ProductTranslations.forEach(productTranslation => {
            if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
              product.displayDetails.name = productTranslation.name
              product.displayDetails.description = productTranslation.description
            } else if (!product.displayDetails.name) {
              product.displayDetails.name = productTranslation.name
              product.displayDetails.description = productTranslation.description
            }
          })
          _products.push(product)
        })
        this.relatedProducts = _products
      }
    },
    closeModal () {
      this.dialog = false
    },
    openRequestModal () {
      if (this.loggedUser.id) {
        this.dialog = !this.dialog
      } else {
        this.$emit('openLogModal')
      }
    },
    sendRequestMessage () {
      if (this.$refs.form.validate()) {
        let request = {
          message: this.requestMessage,
          productId: this.product.id,
          productUserId: this.product.userId,
          userPhoneNumber: this.userData.phoneNumber,
          country: this.userData.country,
          city: this.userData.city

        }
        this.$store.dispatch('products/sendProductRequest', request).then((res) => {
          if (res.errors) {
            this.errors = res.errors
          }
          if (res.productRequest) {
            this.requestMessage = ''
            this.requestedOption.requested = true
            this.closeModal()
            this.$toastr(res.type, res.message, this.$t(res.type))
          }
        }).catch(console.error)
      }
    },
    rejectRequest (id, accept) {
      this.acceptRequest(id, accept)
    },
    confirmRequest (id) {
      if (this.loggedUser) {
        this.contactByTel = this.loggedUser.phoneNumber
        this.contactByEmail = this.loggedUser.email
      }
      this.productId = id
      this.dialogConfirm = true
    },
    acceptRequest (id, accept) {
      if (this.isDisabled) {
        return
      }
      this.isDisabled = true
      let data = {}
      data.id = id
      data.accept = accept
      if (this.enabledTel && this.contactByTel) {
        data.contactByTel = this.contactByTel
      }
      if (this.enabledEmail && this.contactByEmail) {
        data.contactByEmail = this.contactByEmail
      }
      this.$store.dispatch('products/acceptRequest', data).then((response) => {
        setTimeout(() => {
          this.isDisabled = false
        }, this.disabledTimeout)
        this.$toastr(response.type, response.message, this.$t(response.type))
        this.product.ProductRequests = response.productRequests ? response.productRequests : []
      }).catch(console.error)
    },
    close () {
      this.dialogConfirm = false
      setTimeout(() => {
        this.productId = null
      }, 300)
    },
    save () {
      if (this.$refs.formConfirm.validate()) {
        this.acceptRequest(this.productId, true)
        this.close()
      }
    },
    redirectProductEditPage (currentProduct, item) {
      let cat = currentProduct.Category = {}
      cat.CategoryTranslations = []
      cat.CategoryTranslations[0] = {}
      cat.CategoryTranslations[0].name = item[0].text
      cat.id = currentProduct.categoryId
      this.$router.push({name: 'ProfileMyProducts', params: { currentProduct: currentProduct }})
    },
    addToFavorite (item) {
      if (this.loggedUser.id) {
        this.$store.dispatch('products/addToFavorite', item.id).then((res) => {
          if (res.type === 'success') {
            item.favorite = !item.favorite
            this.$toastr(res.type, res.message, this.$t(res.type))
          } else {
            this.$toastr('error', this.$t('something_went_wrong'), this.$t('error'))
          }
        }).catch(console.error)
      } else {
        this.$emit('openLogModal')
      }
    }
  },
  created () {
    EventBus.$on('language-changed', this.languageChanged)
  },
  beforeMount () {
    this.userData = JSON.parse(JSON.stringify(this.loggedUser))
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/desktop/products.scss";
  @import "../../assets/sass/desktop/notificationPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/products/currentProduct.vue